module.exports = __webpack_public_path__ + "img/bingjiang.162c0ab2.png";